module.exports = __webpack_public_path__ + "img/trial2-2.e3e5d04f.png";